angular.module('appSettingTransportation', [
  'ngRoute',
  'ngResource',
  'core',
  'core.auth',
  'core.env',
  'pascalprecht.translate',
]);



// WEBPACK FOOTER //
// ./src/app/app-setting/transportation/transportation.module.js